import { colors } from 'config/themes/colors';
import styled, { css } from 'styled-components';
import { palette } from 'styled-theme';
import { borderRadius, boxShadow, transition } from '../../../config/style-util';

export const BasicInputInteractiveStyles = css`
  &:hover {
    border-color: ${colors.blue[600]};
    box-shadow: none;
  }

  &:focus {
    border-color: ${colors.blue[600]};
    box-shadow: 0 0 0 3px
      ${({ theme }) => (theme.name === 'atsFancy' ? colors.blue[100] : colors.infoBlueDark[700])} !important;
  }
`;

const InputWrapper = (ComponentName) => styled(ComponentName)`
  background-color: ${palette('background', 46)};
  border-color: ${palette('borderColor', 5)};
  border-radius: ${palette('borderRadius', 15)};

  &.ant-input-affix-wrapper {
    color: ${palette('foreground', 0)};
    background-color: ${palette('background', 46)};
    ${BasicInputInteractiveStyles}
  }

  &.ant-input,
  .ant-input {
    padding: 0px 12px;
    width: 100%;
    height: 35px;
    cursor: text;
    text-align: ${(props) => (props['data-rtl'] === 'rtl' ? 'right' : 'left')};
    font-size: 14px;
    line-height: 1.5;
    color: ${palette('foreground', 0)};
    background-color: ${palette('background', 46)};
    background-image: none;
    border: ${palette('borderStyle', 10)};
    ${borderRadius('4px')};
    ${transition()};

    ${BasicInputInteractiveStyles}

    &.ant-input-disabled {
      background-color: ${palette('background', 47)};
      color: ${palette('foreground', 13)};
      cursor: not-allowed;
    }

    &.ant-input-lg {
      height: 42px;
      padding: 6px 10px;
    }

    &.ant-input-sm {
      padding: 1px 4px;
      height: 30px;
    }

    &::-webkit-input-placeholder {
      text-align: ${(props) => (props['data-rtl'] === 'rtl' ? 'right' : 'left')};
      color: ${({ theme }) =>
        theme.name == 'atsFancy' ? palette('grayscale', 0) : theme.text.fadedGray};
    }

    &:-moz-placeholder {
      text-align: ${(props) => (props['data-rtl'] === 'rtl' ? 'right' : 'left')};
      color: ${({ theme }) =>
        theme.name == 'atsFancy' ? palette('grayscale', 0) : theme.text.fadedGray};
    }

    &::-moz-placeholder {
      text-align: ${(props) => (props['data-rtl'] === 'rtl' ? 'right' : 'left')};
      color: ${({ theme }) =>
        theme.name == 'atsFancy' ? palette('grayscale', 0) : theme.text.fadedGray};
    }
    &:-ms-input-placeholder {
      text-align: ${(props) => (props['data-rtl'] === 'rtl' ? 'right' : 'left')};
      color: ${colors.blue[600]};
    }
  }
  .ant-input-group-addon {
    border-color: ${palette('borderColor', 10)};
  }
`;
const InputGroupWrapper = (ComponentName) => styled(ComponentName)`
  &.ant-input-group {
    margin-bottom: 10px;

    .ant-select-auto-complete {
      margin-right: ${(props) => (props['data-rtl'] === 'rtl' ? '-1px' : '0')};
    }

    .ant-input {
      &:first-child {
        border-radius: ${(props) => (props['data-rtl'] === 'rtl' ? '0 4px 4px 0' : '4px 0 0 4px')};
      }
    }

    .ant-input-group-addon:not(:first-child):not(:last-child),
    .ant-input-group-wrap:not(:first-child):not(:last-child),
    > .ant-input:not(:first-child):not(:last-child) {
      padding: 4px 7px;
      border-left-width: ${(props) => (props['data-rtl'] === 'rtl' ? '0' : '1px')};
      margin-right: ${(props) => (props['data-rtl'] === 'rtl' ? '-1px' : '0')};
    }

    .ant-input-group-addon {
      padding: 4px 7px;
      font-size: 12px;
      color: ${palette('text', 1)};
      text-align: center;
      background-color: ${palette('grayscale', 4)};
      border: none;
      box-shadow: 0px 0px 21px 0px #b7b7b72e;
      ${transition()};

      &:first-child {
        border-right-width: ${(props) => (props['data-rtl'] === 'rtl' ? '1px' : '0')};
        border-left-width: ${(props) => (props['data-rtl'] === 'rtl' ? '0' : '1px')};
        border-radius: ${(props) => (props['data-rtl'] === 'rtl' ? '0 4px 4px 0' : '4px 0 0 4px')};
      }

      &:last-child {
        border-right-width: ${(props) => (props['data-rtl'] === 'rtl' ? '0' : '1px')};
        border-left-width: ${(props) => (props['data-rtl'] === 'rtl' ? '1px' : '0')};
        border-radius: ${(props) => (props['data-rtl'] === 'rtl' ? '4px 0 0 4px' : '0 4px 4px 0')};
      }

      .ant-select {
        .ant-select-selector {
          background-color: inherit;
          margin: -1px;
          border: 1px solid transparent;
          ${boxShadow()};
        }
      }
    }

    .ant-input-group-addon:not(:first-child):not(:last-child),
    .ant-input-group-wrap:not(:first-child):not(:last-child) {
      border-left: 0;
      border-right: 0;
    }

    & > .ant-input:not(:first-child):not(:last-child) {
      ${''};
    }

    .ant-input:first-child:last-child {
      border-radius: 4px;
    }

    &.ant-input-group-compact > * {
      border-right-width: ${(props) => (props['data-rtl'] === 'rtl' ? '1px ' : '0')};
    }

    &.ant-input-group-compact > .ant-select > .ant-select-selector,
    &.ant-input-group-compact > .ant-picker .ant-input,
    &.ant-input-group-compact > .ant-select-auto-complete .ant-input,
    &.ant-input-group-compact > .ant-cascader .ant-input,
    &.ant-input-group-compact > .ant-mentions,
    &.ant-input-group-compact > .ant-picker .ant-picker-input > input {
      border-right-width: ${(props) => (props['data-rtl'] === 'rtl' ? '1px ' : '0')};
    }

    &.ant-input-group-compact > *:first-child,
    &.ant-input-group-compact > .ant-select:first-child > .ant-select-selector,
    &.ant-input-group-compact > .ant-picker:first-child .ant-input,
    &.ant-input-group-compact > .ant-select-auto-complete:first-child .ant-input,
    &.ant-input-group-compact > .ant-cascader:first-child .ant-input,
    &.ant-input-group-compact > .ant-mentions:first-child,
    &.ant-input-group-compact > .ant-picker:first-child .ant-picker-input > input {
      border-radius: ${(props) => (props['data-rtl'] === 'rtl' ? '0 4px 4px 0' : '4px 0 0 4px')};
      border-left-width: 1px
        ${
          '' /* border-right-width: ${props =>
        props['data-rtl'] === 'rtl' ? '1px' : '0'}; */
        };
    }

    &.ant-input-group-compact > *:last-child,
    &.ant-input-group-compact > .ant-select:last-child > .ant-select-selector,
    &.ant-input-group-compact > .ant-picker:last-child .ant-input,
    &.ant-input-group-compact > .ant-select-auto-complete:last-child .ant-input,
    &.ant-input-group-compact > .ant-cascader:last-child .ant-input,
    &.ant-input-group-compact > .ant-mentions:last-child,
    &.ant-input-group-compact > .ant-picker:last-child .ant-picker-input > input {
      border-radius: ${(props) => (props['data-rtl'] === 'rtl' ? '4px 0 0 4px' : '0 4px 4px 0')};
      border-right-width: ${(props) => (props['data-rtl'] === 'rtl' ? '0 ' : '1px')};
    }

    .ant-picker-clear,
    .ant-picker-suffix {
      right: ${(props) => (props['data-rtl'] === 'rtl' ? 'inherit' : '8px')};
      left: ${(props) => (props['data-rtl'] === 'rtl' ? '8px' : 'inherit')};
    }
  }

  &.ant-input-group-lg {
    .ant-input,
    > .ant-input-group-addon {
      padding: 6px 10px;
      height: 35px;
    }
  }
`;

const TextAreaWrapper = (ComponentName) => styled(ComponentName)`
  &.ant-input-textarea-affix-wrapper {
    &:hover {
      border-color: transparent !important;
    }
  }

  &.ant-input,
  &.ant-input-textarea-affix-wrapper.ant-input-affix-wrapper > textarea.ant-input {
    padding: 4px 10px;
    width: 100%;
    height: auto;
    cursor: text;
    font-size: 13px;
    line-height: 1.5;
    color: ${palette('foreground', 0)};
    background-color: ${palette('background', 46)};
    background-image: none;
    border: 1px solid ${palette('border', 0)};
    ${borderRadius('4px')};
    ${transition()};
    border: ${palette('borderStyle', 10)};

    &[disabled] {
      color: ${palette('foreground', 13)};
      background-color: ${palette('background', 46)};
    }

    ${BasicInputInteractiveStyles}

    &::-webkit-input-placeholder {
      color: ${({ theme }) =>
        theme.name == 'atsFancy' ? palette('grayscale', 0) : theme.text.fadedGray};
    }

    &:-moz-placeholder {
      color: ${({ theme }) =>
        theme.name == 'atsFancy' ? palette('grayscale', 0) : theme.text.fadedGray};
    }

    &::-moz-placeholder {
      color: ${({ theme }) =>
        theme.name == 'atsFancy' ? palette('grayscale', 0) : theme.text.fadedGray};
    }
    &:-ms-input-placeholder {
      color: ${({ theme }) =>
        theme.name == 'atsFancy' ? palette('grayscale', 0) : theme.text.fadedGray};
    }
  }
`;

const InputSearchWrapper = (ComponentName) => styled(ComponentName)`
  &.ant-input-search {
    .ant-input-affix-wrapper {
      padding-block: 0;
      ${BasicInputInteractiveStyles}
    }

    .ant-input {
      ${BasicInputInteractiveStyles}
      padding: 4px 10px;
      width: 100%;
      height: 35px;
      cursor: text;
      font-size: 13px;
      line-height: 1.5;
      color: ${palette('text', 1)};
      background-color: ${palette('background', 46)};
      background-image: none;
      ${transition()};

      &.ant-input-lg {
        height: 42px;
        padding: 6px 10px;
      }

      &.ant-input-sm {
        padding: 1px 10px;
        height: 30px;
      }

      &::-webkit-input-placeholder {
        color: ${({ theme }) =>
          theme.name == 'atsFancy' ? palette('grayscale', 0) : theme.text.fadedGray};
      }

      &:-moz-placeholder {
        color: ${({ theme }) =>
          theme.name == 'atsFancy' ? palette('grayscale', 0) : theme.text.fadedGray};
      }

      &::-moz-placeholder {
        color: ${({ theme }) =>
          theme.name == 'atsFancy' ? palette('grayscale', 0) : theme.text.fadedGray};
      }
      &:-ms-input-placeholder {
        color: ${({ theme }) =>
          theme.name == 'atsFancy' ? palette('grayscale', 0) : theme.text.fadedGray};
      }
    }

    .ant-input-suffix {
      right: ${(props) => (props['data-rtl'] === 'rtl' ? 'inherit' : '7px')};
      left: ${(props) => (props['data-rtl'] === 'rtl' ? '7px' : 'inherit')};
    }

    .ant-input-ant-input-prefix {
      right: ${(props) => (props['data-rtl'] === 'rtl' ? '7px' : 'inherit')};
      left: ${(props) => (props['data-rtl'] === 'rtl' ? 'inherit' : '7px')};
    }

    .ant-btn-variant-outlined.ant-input-search-btn {
      color: ${({ theme }) =>
        theme.name == 'atsFancy' ? palette('grayscale', 0) : theme.text.fadedGray};
      &:hover {
        /* color: ${palette('primary', 0)}; */
        color: ${({ theme }) =>
          theme.name == 'atsFancy' ? palette('grayscale', 0) : theme.text.fadedGray};
      }
    }
    .ant-input-search-btn {
      height: 35px;
    }
    .ant-btn-lg.ant-input-search-btn {
      height: 42px !important;
    }
    .ant-btn-sm.ant-input-search-btn {
      height: 30px !important;
    }
    .ant-input-search-btn {
      //TODO: maybe here version without shadow
      ${BasicInputInteractiveStyles}
    }
  }
`;

const InputSimpleWrapper = (Component) => styled(Component)`
  &.ant-input,
  &.ant-input-affix-wrapper {
    color: ${palette('foreground', 0)};
    background-color: ${palette('background', 46)};
    border-color: ${palette('borderColor', 10)};
    border-radius: ${palette('borderRadius', 15)};
    &[disabled] {
      background-color: ${palette('background', 46)};
    }

    ${BasicInputInteractiveStyles}
  }

  &::placeholder {
    color: ${({ theme }) =>
      theme.name == 'atsFancy' ? palette('grayscale', 0) : theme.text.fadedGray};
  }

  &.ant-input-affix-wrapper {
    input {
      background-color: ${palette('background', 46)};
      color: ${palette('foreground', 0)};
      &::placeholder {
        color: ${({ theme }) =>
          theme.name == 'atsFancy' ? palette('grayscale', 0) : theme.text.fadedGray};
      }
    }
    &[disabled] {
      input {
        background-color: ${palette('background', 46)};
      }
    }
  }

  &.hide-arrows {
    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    appearance: textfield;
  }
`;

const TextAreaSimpleWrapper = (Component) => styled(Component)`
  &.ant-input-textarea-affix-wrapper {
    &:hover {
      border-color: transparent !important;
    }
  }

  &::placeholder {
    color: ${({ theme }) =>
      theme.name == 'atsFancy' ? palette('grayscale', 0) : theme.text.fadedGray};
  }

  &.ant-input,
  &.ant-input-textarea,
  &.ant-input-textarea-affix-wrapper.ant-input-affix-wrapper > textarea.ant-input {
    color: ${palette('foreground', 0)};
    background-color: ${palette('background', 46)};
    border-color: ${palette('borderColor', 10)};
    &[disabled] {
      background-color: ${palette('background', 46)};
    }

    ${BasicInputInteractiveStyles}
  }
`;

export {
  InputGroupWrapper,
  InputSearchWrapper,
  InputSimpleWrapper,
  InputWrapper,
  TextAreaSimpleWrapper,
  TextAreaWrapper
};

